import moment from 'moment'

const workerTypeMap = new Map([
  ['driver', 'Водитель'],
  ['mover', 'Грузчик'],
  ['furniture', 'Мебельщик'],
  ['garbage', 'Водитель мусоровоза']
]);

const dateRegexp = /^([0-2][0-9]|(3)[0-1])(\.)(((0)[0-9])|((1)[0-2]))(\.)\d{4}$/i;

export default {
  generateRandomStringId () {
    return Math.random().toString(36).slice(2)
  },

  getDefaultAddress () {
    return {
      id: 0,
      lat: null,
      lng: null,
      place: 'Россия, Республика Татарстан, Казань, улица Саид-Галеева',
      comment: '',
      contactPersonName: '',
      contactPersonPhone: ''
    }
  },

  getReferenceAddress () {
    return Object.assign(this.getDefaultAddress(), {
      lat: 55.79371584499595,
      lng: 49.0956809946287
    })
  },

  mapMsToTimeObject (ms) {
    let sec = ms / 1000
    return {
      hours: sec / 3600 % 24,
      minutes: sec / 60 % 60,
      seconds: sec % 60
    }
  },

  calculateServiceDuration (service) {
    return service.realEndTime != null && service.realStartTime != null
      ? service.realEndTime - service.realStartTime
      : service.predictionTime != null
        ? service.predictionTime
        : service.clientTime != null
          ? service.clientTime
          : 0
  },

  calculateStartTime (service) {
    return service.realEndTime != null && service.realStartTime != null
      ? service.realStartTime
      : service.date
  },

  calculateEndTime (service) {
    return service.realEndTime != null && service.realStartTime != null
      ? service.realEndTime
      : service.date + (
        service.predictionTime != null
          ? service.predictionTime
          : service.clientTime != null
            ? service.clientTime
            : 0
      )
  },

  calculateNightHours (service) {
    let serviceStartTime = Number(service.realStartTime != null ? service.realStartTime : service.date);
    let serviceEndTime = Number(service.realEndTime != null ? service.realEndTime :
        serviceStartTime + (service.predictionTime != null ? service.predictionTime :
            (service.clientTime != null ? service.clientTime : 0)));

    let curTime = serviceStartTime;
    let nightMinutes = 0;
    while (curTime < serviceEndTime) {
      let hour = Number(moment(curTime).format("HH"));
      if (hour >= 21 || hour < 7)
        nightMinutes++;

      curTime += 60 * 1000;
    }

    let wholeNightHours = parseInt(nightMinutes / 60);
    let remainderMinutes = nightMinutes % 60;
    if (remainderMinutes >= 11)
      wholeNightHours++;

    if (wholeNightHours == 0) {
      // Если работы были начаты в ночное время, то, независимо от того, сколько времени
      // рабочий проработал ночью (даже 1 минуту), учитываем минимум 1 ночной час
      let startHour = Number(moment(serviceStartTime).format("HH"));
      if (startHour >= 21 || startHour < 7)
        wholeNightHours++;
    }

    return wholeNightHours;
  },

  formatServiceDuration (service) {
    return moment(new Date().getTimezoneOffset() * 60000 + this.calculateServiceDuration(service)).format('HH:mm')
  },

  formatOrderDuration (order) {
    return order.realEndTime == null || order.realStartTime == null
      ? '00:00'
      : moment(order.realEndTime - order.realStartTime + new Date().getTimezoneOffset() * 60000).format('HH:mm')
  },

  getFormattedTimeStringFromLongWithoutTimezone (longValue) {
    if (longValue == null) { return '' }

    let dateTime = new Date(longValue)
    let hours, minutes
    hours = dateTime.getHours() < 10 ? '0' + dateTime.getHours() : dateTime.getHours()
    minutes = dateTime.getMinutes() < 10 ? '0' + dateTime.getMinutes() : dateTime.getMinutes()

    return hours + ':' + minutes
  },

  getFormattedTimeStringFromLongWithTimezone (longValue) {
    if (longValue == null) { return '' }

    let tmpDate = new Date(longValue)
    let dateTime = new Date(tmpDate.getTime() + tmpDate.getTimezoneOffset() * 60 * 1000)

    let hours, minutes
    hours = dateTime.getHours() < 10 ? '0' + dateTime.getHours() : dateTime.getHours()
    minutes = dateTime.getMinutes() < 10 ? '0' + dateTime.getMinutes() : dateTime.getMinutes()

    return hours + ':' + minutes
  },

  getLongFromFormattedTimeString (stringValue) {
    let hours, minutes
    let timeArr = stringValue.split(':')
    hours = timeArr[0] <= 23 ? timeArr[0] : 23
    minutes = timeArr[1] <= 59 ? timeArr[1] : 59
    return hours * 3600000 + minutes * 60000
  },

  sortGroupedServicesByWorkerNullValue (groupedServices) {
    groupedServices.forEach(gs => this.sortServices(gs))

    return groupedServices
  },

  compareGroupedServices (gs1, gs2) {
    return gs1.type == gs2.type &&
      gs1.date == gs2.date &&
      gs1.category.id == gs2.category.id &&
      gs1.clientTime == gs2.clientTime &&
      ((!gs1.addresses && !gs2.addresses) || gs1.addresses.every(e => gs2.addresses.includes(e))) &&
      gs1.paymentType == gs2.paymentType &&
      gs1.inKzn == gs2.inKzn
  },

  spotDistrictByCoords (lat, lng, districts) {
    if (lat != null && lng != null) {
      let districtName;
      for (let district of districts) {
        if (district.points) {
          let xCoordsArray = []
          let yCoordsArray = []

          district.points.forEach(p => {
            xCoordsArray.push(p.lat)
            yCoordsArray.push(p.lng)
          })

          if (this.checkPointIsInRegion(lat, lng, xCoordsArray, yCoordsArray)) {
            districtName = district.name;
            break;
          }
        }
      }
      
      if (districtName) {
        return new Promise((resolve, reject) => resolve(districtName + ' район'));
      } else {
        return ymaps.geocode([lat, lng])
            .then(res => {
              let districtName;
              if (res.geoObjects.getLength() > 0) {
                for (let i = res.geoObjects.getLength() - 1; i >= 0; i--) {
                  let properties = res.geoObjects.get(i).properties.getAll();
                  let kind = properties.metaDataProperty.GeocoderMetaData.kind;

                  let isArea = kind == 'area';
                  let isDistrict = kind == 'district';
                  let name = properties.name;

                  if ((isArea && !districtName) || isDistrict) {
                    districtName = name;
                    if (isDistrict)
                      break;
                  }
                }
              }
              if (!districtName) {
                districtName = 'Неизвестный район'
              }
              return districtName
            })
      }
    } else {
      return new Promise((resolve, reject) => resolve('Неизвестный район'));
    }
  },

  spotRegionByCoords (lat, lng, regions) {
    if (lat != null && lng != null) {
      for (let region of regions) {
        if (region.points) {
          let xCoordsArray = []
          let yCoordsArray = []

          region.points.forEach(p => {
            xCoordsArray.push(p.lat)
            yCoordsArray.push(p.lng)
          })

          if (this.checkPointIsInRegion(lat, lng, xCoordsArray, yCoordsArray)) { return region.name }
        }
      }
    }

    return 'Неизвестная область'
  },

  spotRegionAndDistrictByAddresses (addresses, regions, districts) {
    let result = {
      startRegion: null,
      endRegion: null,
      startDistrict: null,
      endDistrict: null
    }

    // if (true)
    //   return Promise.resolve(result);

    if (!addresses || addresses.length == 0) {
      return Promise.resolve(result)
    }

    let startAddress = addresses[0]
    let endAddress = addresses[addresses.length - 1]

    result.startRegion = this.spotRegionByCoords(startAddress.lat, startAddress.lng, regions)
    result.endRegion = this.spotRegionByCoords(endAddress.lat, endAddress.lng, regions)

    return this.spotDistrictByCoords(startAddress.lat, startAddress.lng, districts)
      .then(districtName => {
        result.startDistrict = districtName
      })
      .then(() => {
        if (addresses.length == 1) {
          result.endDistrict = result.startDistrict
        } else {
          return this.spotDistrictByCoords(endAddress.lat, endAddress.lng, districts)
              .then(districtName => {
                result.endDistrict = districtName
              })
        }
      })
      .then(() => {
        return result
      });
  },

  checkPointIsInRegion (lat, lng, xCoordsArray, yCoordsArray) {
    if (lat == null || lng == null) {
      return 0
    }

    let length = xCoordsArray.length
    let m = length - 1
    let n = 0
    for (let i = 0; i < length; i++) {
      if ((((yCoordsArray[i] <= lng) && (lng < yCoordsArray[m])) || ((yCoordsArray[m] <= lng) && (lng < yCoordsArray[i]))) &&
        (lat > (xCoordsArray[m] - xCoordsArray[i]) * (lng - yCoordsArray[i]) / (yCoordsArray[m] - yCoordsArray[i]) + xCoordsArray[i])) {
        n = !n
      }
      m = i
    }
    return n
  },

  spotOrderSurchargeByRegionInHours (addresses, regions, isTrucking, isMover, isFurniture) {




    let surcharge = 0
    let lastRegionIds = []

    if (addresses && regions) {
      addresses
        .filter(address => address.lat != null && address.lng != null)
        .forEach(address => {
          let filteredRegions = regions
            .filter(region => region.points)
            .filter(region => (isTrucking && region.orderToTrucking) || (isMover && region.orderToMover) || (isFurniture && region.orderToFurniture))
            .filter(region => {
              let xCoordsArray = []
              let yCoordsArray = []

              region.points.forEach(p => {
                xCoordsArray.push(p.lat)
                yCoordsArray.push(p.lng)
              })

              return this.checkPointIsInRegion(address.lat, address.lng, xCoordsArray, yCoordsArray)
            })


          if (filteredRegions.length > 0 && (lastRegionIds.filter(lr => filteredRegions.map(fr => fr.id).includes(lr)).length === 0)) {
            surcharge += Math.max.apply(null, filteredRegions.map(fr => fr.surcharge))
          }

          lastRegionIds = filteredRegions.map(fr => fr.id)
        })
    }

    return surcharge
  },



  getSmallAddressFromFull (place, count, fromStart) {
    let fullAddressArr = place.split(', ')
    let fullAddressArrLength = fullAddressArr.length
    let smallAddress
    // FIXME Учесть площади, подъезды, etc.
    if (!count) {
      count = 2
    }
    if (fullAddressArrLength >= count) {
      if (fromStart) {
        smallAddress = fullAddressArr[0]
        let curPos = 1
        while (curPos < count) {
          smallAddress += ', ' + fullAddressArr[curPos]
          curPos++
        }
      } else {
        smallAddress = fullAddressArr[fullAddressArrLength - 1]
        let curPos = fullAddressArrLength - 2
        while (curPos >= fullAddressArrLength - count) {
          smallAddress = fullAddressArr[curPos] + ', ' + smallAddress
          curPos--
        }
      }
    } else {
      return place
    }
    return smallAddress
  },

  getDateWithoutTime (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
  },

  formatTime(date) {
    return moment(date).format('HH:mm');
  },

  getTimeStringFromLong(longValue) {
    let zeroFill = (num) => (num < 10 ? '0' : '') + num;
    let secondsDuration = Math.floor(longValue / 1000);
    let minutesDuration = Math.floor(secondsDuration / 60);
    let hours = Math.floor(minutesDuration / 60);
    let minutes = minutesDuration % 60;
    return zeroFill(hours) + ":" + zeroFill(minutes);
  },

  getLongFromFormattedDurationString(stringValue) {
    let timeAsArray = stringValue.split(":");
    let hours = parseInt(timeAsArray[0]);
    let minutes = parseInt(timeAsArray[1]);
    let timeInMillis = (hours * 60 + minutes) * 60 * 1000;
    return timeInMillis;
  },

  formatCurrency (amount) {
    return amount.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  },

  getFullName (name, surname, patronymic) {
    return (
      (surname || '') +
      (name ? ' ' + name : '') +
      (patronymic ? ' ' + patronymic : '')
    ).trim()
  },

  changeShadowVisibility (value) {
    let body = document.getElementsByTagName('body')[0]
    value ? body.classList.add('schadow') : body.classList.remove('schadow')
  },

  sortWorkers (workers) {
    return workers.sort((worker1, worker2) => {
      if (!worker1) { return 1 }
      if (!worker2) { return -1 }
      return worker1.name > worker2.name ? -1 : 1
    })
  },

  sortServices (services) {
    return services.sort((service1, service2) => {
      if (service1.worker == null) { return 1 }
      if (service2.worker == null) { return -1 }
      return service1.worker.name > service2.worker.name ? -1 : 1
    })
  },

  isServicePrimary(service) {
    return (service.type != 'OrderToAdditional' || service.category.shippingPacking)
      && service.type != 'OrderToDowntime'
      && service.type != 'OrderToPetrol';
  },

  distinctArray (arr) {
    return arr.filter((elem, pos, arr) => arr.indexOf(elem) == pos)
  },

  checkRole (currentRole, accessForRoles) {
    let access = false
    accessForRoles.forEach(role => {
      if (currentRole === role) { access = true }
    })
    return access
  },

  getWorkerTypeName (workerTypeCode) {
    let workerTypeName = workerTypeMap.get(workerTypeCode)
    if (!workerTypeName) { workerTypeName = 'Рабочий' }
    return workerTypeName
  },

  getCoordsArrayOfAddress (address) {
    let lat = address.lat ? address.lat.toFixed(4) : 0
    let lng = address.lng ? address.lng.toFixed(4) : 0
    return [lat, lng]
  },

  getCoordsStringOfAddress (address) {
    let coordsArray = this.getCoordsArrayOfAddress(address)
    return '' + coordsArray[0] + ';' + coordsArray[1]
  },

  getCoordsArrayOfAddresses (addresses) {
    if (!addresses) { return [] }
    return addresses.map(address => this.getCoordsArrayOfAddress(address))
  },

  checkArraysEquals (arr1, arr2) {
    if ((!arr1 && !arr2) || (!arr1 && arr2.length == 0) || (!arr2 && arr1.length == 0)) {
      return true
    }
    if (arr1.length != arr2.length) {
      return false
    }
    return arr1.filter((el, index) => arr2[index] !== el).length == 0;
  },

  removeWorkerFromService (service) {
    Object.assign(service, {
      worker: null,
      status: 0,
      realStartTime: null,
      realEndTime: null,
      predictionTime: null,
      hasSmsSent: null,
      smsSentTime: null
    })
  },

  spotNewValueForDatePicker(newVal, oldVal) {
    if (!newVal || newVal.length !== 10) {
      if (oldVal === null || (newVal && (oldVal.length - newVal.length === 1 || newVal.length > 10)))
        return null;
      else
        return undefined;
    }

    let newValueByNewVal;
    let isNewValueByNewValValid;

    newValueByNewVal = new Date(newVal.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1'));
    isNewValueByNewValValid = newValueByNewVal instanceof Date && !isNaN(newValueByNewVal);

    return isNewValueByNewValValid ?
      newValueByNewVal : new Date();
  },

  checkIfValidDate(date) {
    return dateRegexp.test(date);
  },

  distinctBy(array, prop) {
    return array.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }
}
